import { toValue, type MaybeRefOrGetter } from 'vue'


export async function useFetch<T = any>(url: MaybeRefOrGetter<string>): Promise<T> {
  const urlValue = toValue(url)
  const response = await fetch(`${urlValue}`)
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  return await response.json()
}
